
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2714_41919)"}},[_c('path',{attrs:{"d":"M18.006 11.433h-2.5c-.918 0-1.668-.75-1.668-1.667V5.597h1.667v4.169h2.501v1.667zM11.338 9.765H1.334v1.667h10.004V9.765z"}}),_c('path',{attrs:{"d":"M18.84 16.435h-1.667a.836.836 0 01-.833-.834.836.836 0 00-.834-.834.836.836 0 00-.834.834.836.836 0 01-.833.834h-2.501a.836.836 0 01-.834-.834V5.597c0-.459.375-.834.834-.834h5.127c.817 0 1.509.584 1.642 1.392l.65 3.919.892.508c.517.3.842.85.842 1.442v2.743h.009c0 .45-.175.867-.484 1.184a1.644 1.644 0 01-1.184.492l.009-.008zm-.975-1.668h1.81-.834v-2.742l-1.25-.71a.842.842 0 01-.41-.591l-.716-4.31H12.17v8.337h.976a2.504 2.504 0 014.718 0v.016z"}}),_c('path',{attrs:{"d":"M12.171 16.435H6.337V15.6a.836.836 0 00-.834-.833.836.836 0 00-.834.833v.834H2.051c-.85 0-1.551-.75-1.551-1.667V3.154c0-.95.692-1.725 1.55-1.725h8.58c.85 0 1.55.775 1.55 1.725v13.28h-.008zm-4.31-1.667h2.643V3.154v-.058H2.176v11.672h.975a2.504 2.504 0 014.719 0H7.86zM15.507 18.102a2.508 2.508 0 01-2.501-2.5 2.508 2.508 0 012.5-2.502 2.508 2.508 0 012.502 2.501 2.508 2.508 0 01-2.501 2.501zm0-3.335a.836.836 0 00-.834.834c0 .459.375.834.834.834a.836.836 0 00.834-.834.836.836 0 00-.834-.834z"}}),_c('path',{attrs:{"d":"M5.503 18.102a2.508 2.508 0 01-2.501-2.5A2.508 2.508 0 015.503 13.1a2.508 2.508 0 012.501 2.501 2.508 2.508 0 01-2.501 2.501zm0-3.335a.836.836 0 00-.834.834c0 .459.375.834.834.834a.836.836 0 00.834-.834.836.836 0 00-.834-.834z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2714_41919"}},[_c('path',{attrs:{"transform":"translate(.5)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    